module.exports = __webpack_public_path__ + "img/mobile_map_cityanalyticsmobility.867e4bd6.svg";